<ng-container *ngIf="isHairFrontPhoto || isHairTopPhoto">
     <cs-icon class="tw-absolute tw-left-6 tw-top-4 tw-h-6 tw-w-6 tw-text-black tw-z-10"
              [iconName]="'arrow_back'"
              (click)="back()"></cs-icon>
     <main class="tw-grid tw-place-content-center tw-flex-col tw-h-full tw-relative tw-pb-[160px] tw-px-9">
          <section class="tw-overflow-hidden">
               <swiper #slider
                       class="tw-pb-14"
                       [config]="carouselConfig">
                    <ng-container *ngIf="user?.get('Gender') === appConfig.Shared.Gender.MALE">
                      <div *swiperSlide
                           class="tw-flex tw-flex-col tw-items-center tw-justify-center tw-pt-20 tw-gap-4">
                        <img class="tw-rounded-5"
                             *ngIf="isHairFrontPhoto"
                             src="https://cdn.cureskin.com/app/img/hair_instruction_male_1_new.png"
                             alt="male hair instruction">
                        <img class="tw-rounded-5"
                             *ngIf="isHairTopPhoto"
                             src="https://cdn.cureskin.com/app/img/hair_top_instruction_male_1.png"
                             alt="male hair top instruction">
                        <h2 class="tw-font-body tw-text-black tw-text-center tw-text-500"
                            i18n="@@holdYourHairBack">
                          Hold your <br>hair back</h2>
                      </div>
                    </ng-container>
                   <ng-container *ngIf="user?.get('Gender') === appConfig.Shared.Gender.FEMALE && isHairTopPhoto">
                     <div *swiperSlide
                          class="tw-flex tw-flex-col tw-items-center tw-justify-center tw-pt-20 tw-gap-4">
                       <img class="tw-rounded-5" src="https://cdn.cureskin.com/app/img/hair_instruction_female_1.png" alt="hair instruction">
                       <h2 class="tw-font-body tw-text-black tw-text-center tw-text-500" i18n="@@centerPartitionWithHair">Center partition with hair behind shoulder</h2>
                     </div>
                   </ng-container>
                    <div *swiperSlide
                         class="tw-flex tw-flex-col tw-items-center tw-justify-center tw-pt-20 tw-gap-4">
                         <img class="tw-rounded-5"
                              *ngIf="user?.get('Gender') === appConfig.Shared.Gender.MALE && isHairFrontPhoto"
                              src="https://cdn.cureskin.com/app/img/hair_instruction_male_2_new.png"
                              alt="hair instruction">
                         <img class="tw-rounded-5"
                              *ngIf="user?.get('Gender') === appConfig.Shared.Gender.MALE && isHairTopPhoto"
                              src="https://cdn.cureskin.com/app/img/hair_top_instruction_male_2.png"
                              alt="hair top instruction">
                         <img class="tw-rounded-5"
                              *ngIf="user?.get('Gender') !== appConfig.Shared.Gender.MALE && isHairFrontPhoto"
                              src="https://cdn.cureskin.com/app/img/hair_instruction_female_2.png"
                              alt="hair instruction female">
                         <img class="tw-rounded-5"
                              *ngIf="user?.get('Gender') !== appConfig.Shared.Gender.MALE && isHairTopPhoto"
                              src="https://cdn.cureskin.com/app/img/hair_top_instruction_female_2.png"
                              alt="hair top instruction">
                         <h2 *ngIf="isHairFrontPhoto"
                             class="tw-font-body tw-text-black tw-text-center tw-text-500"
                             i18n="@@holdPhoneInFront">
                              Hold phone in front <br>of your face</h2>
                         <h2 *ngIf="isHairTopPhoto"
                             class="tw-font-body tw-text-black tw-text-center tw-text-500"
                             i18n="@@tiltYourHeadTowardsCamera">Tilt your head <br> towards camera</h2>
                    </div>
                    <ng-container *ngIf="(user?.get('Gender') !== appConfig.Shared.Gender.MALE) && !isHairTopPhoto">
                         <div *swiperSlide
                              class="tw-flex tw-flex-col tw-items-center tw-justify-center tw-pt-20 tw-gap-4">
                              <img class="tw-rounded-5"
                                   *ngIf="user?.get('Gender') === appConfig.Shared.Gender.MALE  && isHairFrontPhoto"
                                   src="https://cdn.cureskin.com/app/img/hair_instruction_male_3_new.png"
                                   alt="hair instruction">
                              <img class="tw-rounded-5"
                                   *ngIf="user?.get('Gender') !== appConfig.Shared.Gender.MALE"
                                   src="https://cdn.cureskin.com/app/img/hair_instruction_female_3.png"
                                   alt="hair instruction">
                              <h2 class="tw-font-body tw-text-black tw-text-center tw-text-500" i18n="@@makeCenterPartitionAndFitOval">
                                   Make center partition <br> & fit your face in oval
                              </h2>
                         </div>
                    </ng-container>
                    <ng-container *ngIf="!isHairTopPhoto">
                         <div *swiperSlide
                              class="tw-flex tw-flex-col tw-items-center tw-justify-center tw-pt-20 tw-gap-4">
                              <div class="tw-relative">
                                   <img class="tw-rounded-5"
                                        *ngIf="user?.get('Gender') === appConfig.Shared.Gender.MALE  && isHairFrontPhoto"
                                        src="https://cdn.cureskin.com/app/img/hair_instruction_male_4.png"
                                        alt="hair instruction">
                                   <img class="tw-rounded-5"
                                        *ngIf="user?.get('Gender') !== appConfig.Shared.Gender.MALE"
                                        src="https://cdn.cureskin.com/app/img/hair_instruction_female_4.png"
                                        alt="female hair instruction">
                                   <div
                                        class="tw-flex tw-gap-1 tw-justify-around tw-items-center tw-w-full tw-absolute -tw-bottom-4">
                                        <div
                                             class="tw-bg-orange-400 tw-rounded-full tw-h-8 tw-w-8 tw-flex tw-items-center tw-justify-center">
                                             <cs-icon class="tw-h-6 tw-w-6 tw-text-white"
                                                      [iconName]="'close'"></cs-icon>
                                        </div>
                                        <div
                                             class="tw-bg-green-400 tw-rounded-full tw-h-8 tw-w-8 tw-flex tw-items-center tw-justify-center">
                                             <cs-icon class="tw-h-6 tw-w-6 tw-text-white"
                                                      [iconName]="'done'"></cs-icon>
                                        </div>
                                   </div>
                              </div>
                              <h2 class="tw-font-body tw-text-700 tw-text-black tw-text-center"
                                  i18n="@@removeGlasses">
                                   Remove glasses</h2>
                         </div>
                    </ng-container>
               </swiper>
          </section>
          <footer
                  class="tw-absolute tw-bottom-0 tw-right-0 tw-left-0 tw-h-[160px] tw-flex tw-flex-col tw-gap-4 tw-px-6 tw-py-7">
               @if (!slider?.swiperRef?.isEnd && !isCarouselReachedEnd) {
               <button csButton="outlined"
                       type="button"
                       class="tw-w-full"
                       (click)="slider?.swiperRef.slideNext()"
                       i18n="@@next">Next
               </button>
               }
               @if (slider?.swiperRef?.isEnd || isCarouselReachedEnd) {
               <button csButton
                       type="button"
                       i18n="@@continue"
                       class="tw-w-full"
                       (click)="takePhoto()">Continue</button>
               }
               <div class="tw-flex tw-items-center tw-justify-center tw-gap-1">
                    <cs-icon class="tw-h-4 tw-w-4 tw-text-gray-500 tw-mb-0.5"
                             [iconName]="'lock-solid'"></cs-icon>
                    <span class="tw-font-body tw-text-100 tw-text-gray-500"
                          i18n="@@securePhotoPrivacyProtected">Secure Photo | Privacy Protected</span>
               </div>
          </footer>
     </main>
</ng-container>

<ng-container *ngIf="!(isHairFrontPhoto || isHairTopPhoto)">
     <cs-icon class="tw-absolute tw-left-6 tw-top-4 tw-h-6 tw-w-6 tw-text-black tw-z-10"
              [iconName]="'arrow_back'"
              (click)="back()"></cs-icon>
     <main class="tw-grid tw-place-content-center tw-flex-col tw-h-full tw-relative tw-pb-[160px] tw-px-9">
          <section class="tw-overflow-hidden">
               <swiper #slider
                       class="tw-pb-14"
                       [config]="carouselConfig">
                    <div *swiperSlide
                         class="tw-flex tw-flex-col tw-items-center tw-justify-center tw-pt-20 tw-gap-4">
                         <img class="tw-rounded-5"
                              *ngIf="user?.get('Gender') === appConfig.Shared.Gender.MALE && isFrontFacePhoto"
                              src="https://cdn.cureskin.com/app/img/hair_instruction_male_2.png"
                              alt="hair male instruction">
                         <img class="tw-rounded-5"
                              *ngIf="user?.get('Gender') === appConfig.Shared.Gender.MALE && isSideFacePhoto"
                              src="https://cdn.cureskin.com/app/img/face_side_instruction_male_1.png"
                              alt="face male instruction">
                         <img class="tw-rounded-5"
                              *ngIf="user?.get('Gender') !== appConfig.Shared.Gender.MALE && isFrontFacePhoto"
                              src="https://cdn.cureskin.com/app/img/hair_instruction_female_2.png"
                              alt="face female instruction">
                         <img class="tw-rounded-5"
                              *ngIf="user?.get('Gender') !== appConfig.Shared.Gender.MALE && isSideFacePhoto"
                              src="https://cdn.cureskin.com/app/img/face_side_instruction_female_1.png"
                              alt="face side instruction">
                         <h2 *ngIf="isFrontFacePhoto"
                             class="tw-font-body tw-text-black tw-text-center tw-text-500"
                             i18n="@@holdPhoneInFront">
                              Hold phone in front <br>of your face</h2>
                         <h2 *ngIf="isSideFacePhoto"
                             class="tw-font-body tw-text-black tw-text-center tw-text-500"
                             i18n="@@holdPhoneOnSide">Hold phone on side of <br>your face</h2>
                    </div>
                    <ng-container *ngIf="isFrontFacePhoto">
                         <div *swiperSlide
                              class="tw-flex tw-flex-col tw-items-center tw-justify-center tw-pt-20 tw-gap-4">
                              <div class="tw-relative">
                                   <img class="tw-rounded-5"
                                        *ngIf="user?.get('Gender') === appConfig.Shared.Gender.MALE"
                                        src="https://cdn.cureskin.com/app/img/hair_instruction_male_4.png"
                                        alt="hair male instruction">
                                   <img class="tw-rounded-5"
                                        *ngIf="user?.get('Gender') !== appConfig.Shared.Gender.MALE"
                                        src="https://cdn.cureskin.com/app/img/hair_instruction_female_4.png"
                                        alt="hair female instruction">
                                   <div
                                        class="tw-flex tw-gap-1 tw-justify-around tw-items-center tw-w-full tw-absolute -tw-bottom-4">
                                        <div
                                             class="tw-bg-orange-400 tw-rounded-full tw-h-8 tw-w-8 tw-flex tw-items-center tw-justify-center">
                                             <cs-icon class="tw-h-6 tw-w-6 tw-text-white"
                                                      [iconName]="'close'"></cs-icon>
                                        </div>
                                        <div
                                             class="tw-bg-green-400 tw-rounded-full tw-h-8 tw-w-8 tw-flex tw-items-center tw-justify-center">
                                             <cs-icon class="tw-h-6 tw-w-6 tw-text-white"
                                                      [iconName]="'done'"></cs-icon>
                                        </div>
                                   </div>
                              </div>
                              <h2 *ngIf="user?.get('Gender') === appConfig.Shared.Gender.MALE"
                                  class="tw-font-body tw-text-black tw-text-center tw-text-500"
                                  i18n="@@removeGlasses">
                                   Remove glasses</h2>
                              <h2 *ngIf="user?.get('Gender') !== appConfig.Shared.Gender.MALE"
                                  class="tw-font-body tw-text-black tw-text-center tw-text-500"
                                  i18n="@@removeGlassesAndMakeup">
                                   Remove glasses <br>& makeup</h2>
                         </div>
                    </ng-container>
                    <ng-container *ngIf="isSideFacePhoto">
                         <div *swiperSlide
                              class="tw-flex tw-flex-col tw-items-center tw-justify-center tw-pt-20 tw-gap-4">
                              <div class="tw-relative">
                                   <img class="tw-rounded-5"
                                        *ngIf="user?.get('Gender') === appConfig.Shared.Gender.MALE"
                                        src="https://cdn.cureskin.com/app/img/face_side_instruction_male_2.png"
                                        alt="fece side instruction">
                                   <img class="tw-rounded-5"
                                        *ngIf="user?.get('Gender') !== appConfig.Shared.Gender.MALE"
                                        src="https://cdn.cureskin.com/app/img/face_side_instruction_female_2.png"
                                        alt="face female side instruction">
                                   <div
                                        class="tw-flex tw-gap-1 tw-justify-around tw-items-center tw-w-full tw-absolute -tw-top-4">
                                        <div
                                             class="tw-bg-orange-400 tw-rounded-full tw-h-8 tw-w-8 tw-flex tw-items-center tw-justify-center">
                                             <cs-icon class="tw-h-6 tw-w-6 tw-text-white"
                                                      [iconName]="'close'"></cs-icon>
                                        </div>
                                        <div
                                             class="tw-bg-green-400 tw-rounded-full tw-h-8 tw-w-8 tw-flex tw-items-center tw-justify-center">
                                             <cs-icon class="tw-h-6 tw-w-6 tw-text-white"
                                                      [iconName]="'done'"></cs-icon>
                                        </div>
                                   </div>
                              </div>
                              <h2 *ngIf="user?.get('Gender') === appConfig.Shared.Gender.MALE"
                                  class="tw-font-body tw-text-black tw-text-center tw-text-500"
                                  i18n="@@ensureNaturalLight">
                                   Ensure natural light <br>for clear face detection</h2>
                              <h2 *ngIf="user?.get('Gender') !== appConfig.Shared.Gender.MALE"
                                  class="tw-font-body tw-text-black tw-text-center tw-text-500"
                                  i18n="@@pullHairBack">
                                   Pull your hair back, <br>ensure natural lighting</h2>
                         </div>
                    </ng-container>
                    <ng-container *ngIf="isFrontFacePhoto">
                         <div *swiperSlide
                              class="tw-flex tw-flex-col tw-items-center tw-justify-center tw-pt-20 tw-gap-4">
                              <img class="tw-rounded-5"
                                   *ngIf="user?.get('Gender') === appConfig.Shared.Gender.MALE"
                                   src="https://cdn.cureskin.com/app/img/hair_instruction_male_3.png"
                                   alt="hair instruction">
                              <img class="tw-rounded-5"
                                   *ngIf="user?.get('Gender') !== appConfig.Shared.Gender.MALE"
                                   src="https://cdn.cureskin.com/app/img/hair_instruction_female_3.png"
                                   alt="hair instruction">
                              <h2 class="tw-font-body tw-text-black tw-text-center tw-text-500"
                                  i18n="@@fitYourFaceInTheOval">
                                   Fit your face in <br>the oval</h2>
                         </div>
                    </ng-container>
               </swiper>
          </section>
          <footer
                  class="tw-fixed tw-bottom-0 tw-right-0 tw-left-0 tw-h-[160px] tw-flex tw-flex-col tw-gap-4 tw-px-6 tw-py-7">
               @if (slider?.swiperRef?.slides?.length && !slider?.swiperRef?.isEnd && !isCarouselReachedEnd) {
               <button csButton="outlined"
                       type="button"
                       class="tw-w-full"
                       (click)="slider?.swiperRef.slideNext()"
                       i18n="@@next">Next
               </button>
               }
               @if (!slider?.swiperRef?.slides?.length || slider?.swiperRef?.isEnd || isCarouselReachedEnd) {
               <button csButton
                       type="button"
                       i18n="@@continue"
                       class="tw-w-full"
                       (click)="takePhoto()">Continue</button>
               }
               <div class="tw-flex tw-items-center tw-justify-center tw-gap-1">
                    <cs-icon class="tw-h-4 tw-w-4 tw-text-gray-500 tw-mb-0.5"
                             [iconName]="'lock-solid'"></cs-icon>
                    <span class="tw-font-body tw-text-100 tw-text-gray-500"
                          i18n="@@securePhotoPrivacyProtected">Secure Photo | Privacy Protected</span>
               </div>
          </footer>
     </main>
</ng-container>

<file-picker (onFileChange)="uploadImageFromNativeCamera($event)"
             capture="user"></file-picker>
